// @ utilities
import { formatText } from 'core/i18n';

const YEARS = {
    2: {
        0: formatText('rentabilityGraph-today'),
        11: formatText('rentabilityGraph-nMonths', ['2']),
        22: formatText('rentabilityGraph-nMonths', ['12']),
        33: formatText('rentabilityGraph-nMonths', ['18']),
        44: formatText('rentabilityGraph-nMonths', ['24']),
    },
    10: {
        0: formatText('rentabilityGraph-today'),
        13: formatText('rentabilityGraph-nYears', ['2']),
        26: formatText('rentabilityGraph-nYears', ['4']),
        39: formatText('rentabilityGraph-nYears', ['6']),
        52: formatText('rentabilityGraph-nYears', ['8']),
        65: formatText('rentabilityGraph-nYears', ['10']),
    },
    25: {
        0: formatText('rentabilityGraph-today'),
        21: formatText('rentabilityGraph-nYears', ['5']),
        42: formatText('rentabilityGraph-nYears', ['10']),
        63: formatText('rentabilityGraph-nYears', ['15']),
        84: formatText('rentabilityGraph-nYears', ['20']),
        105: formatText('rentabilityGraph-nYears', ['25']),
    },
};

const YEARS_INITIALS = {
    2: {
        0: formatText('rentabilityGraph-today'),
        11: formatText('rentabilityGraph-nMonthsInitials', ['6']),
        22: formatText('rentabilityGraph-nMonthsInitials', ['12']),
        33: formatText('rentabilityGraph-nMonthsInitials', ['18']),
        44: formatText('rentabilityGraph-nMonthsInitials', ['24']),
    },
    10: {
        0: formatText('rentabilityGraph-today'),
        13: formatText('rentabilityGraph-nYearsInitials', ['2']),
        26: formatText('rentabilityGraph-nYearsInitials', ['4']),
        39: formatText('rentabilityGraph-nYearsInitials', ['6']),
        52: formatText('rentabilityGraph-nYearsInitials', ['8']),
        65: formatText('rentabilityGraph-nYearsInitials', ['10']),
    },
    25: {
        0: formatText('rentabilityGraph-today'),
        21: formatText('rentabilityGraph-nYearsInitials', ['5']),
        42: formatText('rentabilityGraph-nYearsInitials', ['10']),
        63: formatText('rentabilityGraph-nYearsInitials', ['15']),
        84: formatText('rentabilityGraph-nYearsInitials', ['20']),
        105: formatText('rentabilityGraph-nYearsInitials', ['25']),
    },
};

export default {
    YEARS,
    YEARS_INITIALS,
};
